module.exports = __webpack_public_path__ + "images/top-icon-classify.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/top-icon-classify.png
// module id = 893
// module chunks = 121